var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7501 8.25007C21.1932 3.69318 13.8068 3.69318 9.25 8.25C4.69318 12.8068 4.69318 20.1932 9.25007 24.7501C13.8068 29.3068 21.1932 29.3068 25.75 24.75C30.3068 20.1932 30.3068 12.8068 25.7501 8.25007ZM18.6667 20.8999C18.6667 21.5445 18.1446 22.0665 17.5001 22.0666C16.8551 22.0666 16.3334 21.5443 16.3335 20.8999L16.3334 17.6666H13.1001C12.4551 17.6666 11.9334 17.1443 11.9335 16.4999C11.9335 15.8554 12.4555 15.3333 13.1001 15.3333H16.3335L16.3334 12.1C16.3334 11.4555 16.8555 10.9334 17.5 10.9334C18.1445 10.9334 18.6666 11.4555 18.6666 12.1V15.3334L21.9 15.3334C22.5445 15.3334 23.0666 15.8555 23.0666 16.5C23.0666 17.1445 22.5445 17.6666 21.9 17.6666L18.6667 17.6665L18.6667 20.8999Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plusIcon.f0a738cd689ade215d7f20b9eef6e349.svg";
export { ForwardRef as ReactComponent };